import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";
import namakaLogo from "../../../../assets/img/clients/namaka-cropped.webp";
import fmecaThumbnail from "../../../../assets/img/caseStudies/namakaFmeca.webp";

export default function NamakaFmeca() {
 const caseStudy = new CaseStudyTemplate(
  "NAMAKA Subsea: FMECA Reporting System",
  (
   <div>
    <p>
     Namaka Subsea needed a digital solution to streamline FMECA (Failure Mode, Effects and Criticality Analysis) reporting for offshore technicians—where reliable internet access can be a challenge. The tool had to be intuitive, guide users through complex processes, and work seamlessly even when offline.
    </p>
    <p>
     DEV4 developed a cloud-based FMECA tool using progressive web app (PWA) technology and robust data synchronization. This allows technicians to collect and manage FMECA data offline, with automatic synchronization to central storage when internet connectivity is restored. The system guides users step-by-step through the process, showing progress and outstanding tasks.
    </p>
    <strong>The Results</strong>
    <ul>
     <li>Works Anywhere: Reliable operation offshore, even with limited or no internet access.</li>
     <li>User-Friendly: Intuitive guidance through complex FMECA tasks.</li>
     <li>Efficient & Safe: Ensures all critical analysis is completed, tracked, and securely stored.</li>
    </ul>
   </div>
  ),
  fmecaThumbnail,
  new Company(
   "Namaka Subsea",
   namakaLogo,
   {
    width: "22.5%"
   }
  ),
  "https://www.namakasubsea.com/",
  [
   technologies.aspNET,
   technologies.telerik,
   technologies.azure,
   technologies.sqlServer
  ]
 )

 return (
  <CaseStudy caseStudy={caseStudy} bgColor="rgba(0, 0, 0, 0)" thumbSize="100%"></CaseStudy>
 )
}